type CouponLike = {
  discount_amount: number;
  discount_type: string;
  min_purchase: number;
  discount_rate: number;
  max_discount: number;
};

export function calcCouponSaleAmount(obj: CouponLike, price: number): number {
  if (price < obj.min_purchase) {
    return 0;
  }
  if (obj.discount_type === "price") {
    if (price < obj.discount_amount) {
      return price;
    }
    return obj.discount_amount;
  }
  const amount = Math.floor((price * obj.discount_rate) / 100);
  if (amount > obj.max_discount) {
    return obj.max_discount;
  }
  return amount;
}
